// extracted by mini-css-extract-plugin
export default {"thread":"vp_hso8C","viewport":"vp_yzh7P","content":"vp_q4Hox","message":"vp_gpnRl","footer":"vp_m7kdW","footerContent":"vp_j3919","scrollToBottom":"vp_gYKtx"};